import { FilesClass } from './uploads-class';
import { Icon } from './common-class';

export enum ProductCategory {
  ResponsabilidadeCivil = 'ResponsabilidadeCivil',
  AcidentesTrabalho = 'AcidentesTrabalho',
  Vida = 'Vida',
  EquipamentosMultimedia = 'EquipamentosMultimedia',
  Poupanca = 'Poupanca',
  AutomovelMota = 'AutomovelMota',
  Caucao = 'Caucao',
  Multirriscos = 'Multirriscos',
  Saude = 'Saude',
  Viagem = 'Viagem',
  Animais = 'Animais',
  Embarcacao = 'Embarcacao',
  EquipamentoEletronico = 'EquipamentoEletronico',
  AcidentesPessoais = 'AcidentesPessoais',
  TVDE = 'TVDE',
  Other = 'Other',
}

export class ProductsClass {
  idCompanie: number | null = null;
  idProduct: number | null = null;
  ProductsTitle: string = '';
  Name: string = '';
  ShortName: string = '';
  Description: string = '';
  SeoDescription: string = '';
  SeoTitle: string = '';
  comments: string = '';
  Icon: Icon | string | null = null;
  IconDestaque: Icon | string | null = null;
  IconMaxWidth: number | null = null;
  IconMinWidth: number | null = null;
  IconMaxHeight: number | null = null;
  IconMinHeight: number | null = null;
  IconURL: any; // SafeUrl | string | null;
  EffectiveIcon?: Icon | string | null;
  IconDestaqueURL: any; // SafeUrl | string | null;
  TextColor: string = '#000000';
  BackgroundColor: string = '#ffffff';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  ProdutoInativo: boolean = false;
  Order: number | null = null;
  OrderOptions: number | null = null;
  IsForSale: boolean = false;
  VisibleOptions: boolean = false;
  File: Blob | null = null;
  FileURL: string = '';
  ShowMatricula: boolean = false;
  ShowCapital: boolean = false;
  ShowSalario: boolean = false;

  ShowParticularNIF: boolean = false;
  ShowEnterpriseNIF: boolean = false;
  ShowProductsHomeFeatured: boolean = false;
  isProduct: boolean = false;
  ShowCarInspection: boolean = false;
  ShowInsuranceClaimsCausesTypes: boolean = false;
  Unavailable: boolean = false;

  ProductCategory: ProductCategory | string = ProductCategory.Other;

  UUID: string = '';
  Slug: string = '';
  productsTypesClass: ProductsTypesClass[] = [];
  productsClaimsCompaniesClass: ProductsClaimsCompaniesClass[] = [];
  TotalSubProdutos: number | null = null;
  UUIDLastChange: string = '';
  idProductsTypes: number | null = null;
  IsWait: boolean = false;
  configDocumentsForm: ConfigDocumentsForm[] = [];
  _isParent?: boolean;
  _isSubproduct?: boolean;
}

export class ConfigDocumentsForm {
  botao: string = '';
  AGEASCode: string[] = [];
  TranquilidadeCode: string[] = [];
  order: number = 0;
}

export class ProductsTypesClaimsCausesPDFClass {
  idProductsTypesClaimsCausesPDF: number | null = null;
  idProduct: number | null = null;
  idProductsTypes: number | null = null;
  idInsuranceClaimsCausesTypes: number | null = null;
  idCompanie: number | null = null;
  DocumentName: string = '';
  Description: string = '';
  updated: string = '';
  FilePath: string = '';
  type: string = '';
  size: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class ProductsTypesClass {
  idCompanie: number | null = null;
  idProductsTypes: number | null = null;
  idProduct: number | null = null;
  ProductsName: string = '';
  ProductsBackgroundColor: string = '';
  ProductsDescription: string = '';
  ProductsTextColor: string = '';
  Name: string = '';
  ShortName: string = '';
  Description: string = '';
  SeoDescription: string = '';
  SeoTitle: string = '';
  comments: string = '';
  TicketObservations?: string = '';
  Icon: Icon | string | null = null;
  IconMaxWidth: number | null = null;

  // Custom properties for UI grouping
  _isHeader?: boolean;
  _treeName?: string;
  _isParentProduct?: boolean;
  level?: number;
  IconMinWidth: number | null = null;
  IconMaxHeight: number | null = null;
  IconMinHeight: number | null = null;
  IconDestaque: Icon | string | null = null;
  Image: Icon | string | null = null;
  IconURL?: any;
  EffectiveIcon?: Icon | string | null;
  IconDestaqueURL?: any;
  TextColor: string = '#000000';
  BackgroundColor: string = '#ffffff';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  ProdutoInativo: boolean = false;
  Order: number | null = null;
  openVisibilityPanel?: boolean;
  OrderOptions: number | null = null;
  ShowInProductsList: boolean = false;
  OrderInProductsList: number | null = null;
  idProductsTypesOwner: number | null = null;
  idPaymentsTypesDefault: number | null = null;
  idCommonAutoVehicleSelectionDefault: number | null = null;
  idCommonAutoVehicleTypeDefault: number | null = null;
  idCommonAutoVehicleUsageDefault: number | null = null;
  // AllowChangeidPaymentsTypes: boolean = false;
  isCheckable: boolean = false;
  isSlideValue: boolean = false;
  OpenComponent: string = '';
  OpenComponentCotacoes: string = '';
  OpenproposalsComponent: string = '';
  OpenpurchaseComponent: string = '';
  OpenInsuranceClaimsComponent: string = '';
  SkipQuiz: boolean = false;
  File: Blob | null = null;
  FileURL: string = '';
  EmailSendFile: string = '';
  LibertyCode: string = '';

  ItemTemplatemaxwidth: number | null = 250;
  ItemTemplateminwidth: number | null = 150;
  ItemTemplatewidth: number | null = 250;

  Proposalsmaxwidth: number | null = 250;
  Proposalsminwidth: number | null = 150;
  Proposalswidth: number | null = 250;

  FooterText1: string = '';
  FooterText2: string = '';

  ShowLibertyParticipaRegatas: boolean = false;
  ShowInsuranceClaims: boolean = false;
  ShowInsuranceClaimsSignature: boolean = false;
  showButtonHealthCard: boolean = false;
  showButtonHealthExpenses: boolean = false;
  showButtonHealthMedicalNetwork: boolean = false;

  ShowMatricula: boolean = false;
  ShowCapital: boolean = false;
  ShowSalario: boolean = false;
  isProduct: boolean = false;
  ShowCarInspection: boolean = false;
  ShowInsuranceClaimsCausesTypes: boolean = false;

  ShowParticularNIF: boolean = false;
  ShowEnterpriseNIF: boolean = false;

  IsForSale: boolean = false;
  ShowProductsHomeFeatured: boolean = false;
  ShowInHomeSearch: boolean = false;
  ShowOnlyLoggedUser: boolean = false;

  IsWait: boolean = false;

  SendPurchaseToEmail: string = '';
  SameClaimsAllCompanies: boolean = false;

  CartaVerde: boolean = false;
  Unavailable: boolean = false;
  RemoveLogPDFQuoteRequest: boolean = false;
  UUID: string = '';
  Slug: string = '';
  UUIDLastChange: string = '';
  _isParent?: boolean;
  _isSubproduct?: boolean;
  _parentSlug?: string;
  children?: ProductsTypesClass[];
}

export class ProductsClaimsCompaniesClass {
  idProductsClaimsCompanies: number | null = null;
  idCompanie: number | null = null;
  idProduct: number | null = null;
  ProductName: string = '';
  idProductsTypes: number | null = null;
  Name: string = '';
  idProductsTypesOwner: number | null = null;
  isCheckable: number | null = null;
  path: string = '';
  Nivel: number | null = null;
  Enabled: boolean = false;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  comments: string = '';
  Color: string = '';
  Text: string = '';
  Email: string = '';
  files: number | null = null;
  ShowInsuranceClaimsSignature: boolean = false;
  UUID: string = '';
  ProductsTypesClaimsFiles: FilesClass[] = [];
  CartaVerde: boolean = false;
  UUIDLastChange: string = '';
}
